module.exports = __webpack_public_path__ + "media/reskin-images/icon--case-ce0b099c.svg";